<div class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">

    <form [formGroup]="formGroup" novalidate>

        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtName}}" formControlName="C_Name" [(ngModel)]="parent.order.C_Name" required
                    maxlength="100">
                <mat-error *ngIf="formGroupErrors.C_Name.required">
                    {{translations.msgPleaseEnterCustomerName}}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="mr-24 {{pcRequired ? 'ng-invalid mat-input-invalid mat-form-field-invalid' : ' mat-input-container mat-form-field ng-tns-c18-22 mat-form-field-type-mat-input mat-form-field-can-float mat-primary ng-touched mat-form-field-should-float ng-dirty ng-valid'}}"
             fxFlex.xs="100" fxFlex="50">
                <!-- <mat-select placeholder="{{translations.txtPostalCode}} " formControlName="C_PostalCodeId" (change)="changePostalCode($event)"
                    [(ngModel)]="parent.order.C_PostalCodeId" required>
                    <ngx-mat-select-search [formControl]="pcFilterCtrl" [noEntriesFoundLabel]="translations.msgNoRecordFound"></ngx-mat-select-search>
                    <mat-option *ngFor="let pc of postalCodeList" [value]="pc.Id">{{pc.Description}} ({{pc.Code}})</mat-option>
                </mat-select>

                <mat-error *ngIf="formGroupErrors.C_PostalCodeId.required">
                    {{translations.msgPleaseSelectPostalCode}}
                </mat-error> -->
                <input type="text" placeholder="{{translations.txtPostalCode}} *" formControlName="C_PostalCodeId" matInput [formControl]="pcFilterCtrl" [matAutocomplete]="auto"  (blur)="onPCBlur($event)" readonly>
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                    <mat-option *ngFor="let pc of postalCodeList" 
                    value="{{pc.Description}} ({{pc.Code}})"
                    (onSelectionChange)="changePostalCode(pc.Id,pc.Description,pc.Code)"
                    >{{pc.Description}} ({{pc.Code}})</mat-option>
                </mat-autocomplete>
                <mat-hint align="start" *ngIf="pcRequired" style="color:red">{{translations.msgPleaseSelectPostalCode}}</mat-hint>
            </mat-form-field>


        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <textarea matInput placeholder="{{translations.txtAddress}}" formControlName="C_Address" [(ngModel)]="parent.order.C_Address"
                    required maxlength="500">
                                 </textarea>
                <mat-error *ngIf="formGroupErrors.C_Address.required">
                    {{translations.msgPleaseEnterAddress}}
                </mat-error>
            </mat-form-field>
             <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.lblCHouseNumber}}" formControlName="C_HouseNo" [(ngModel)]="parent.order.C_HouseNo">
                <!-- <mat-error *ngIf="formGroupErrors.C_Email.required">
                     {{translations.msgEnterCHouseNo}}
                    </mat-error> -->
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtCity}}" formControlName="City" [(ngModel)]="parent.order.City" disabled>

            </mat-form-field>

            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtRegion}}" formControlName="Region" [(ngModel)]="parent.order.Region" disabled>

            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                        <input matInput placeholder="{{translations.txtCanton}}" formControlName="Canton" [(ngModel)]="parent.order.Canton" disabled>
        
                    </mat-form-field>
            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                <input matInput placeholder="{{translations.txtCountry}}" formControlName="Country" [(ngModel)]="parent.order.Country" disabled>

            </mat-form-field>
        </div>

         <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24 single-field" fxFlex.xs="100" fxFlex="50">
                    <input matInput placeholder="{{translations.lblCEmail}}" formControlName="C_Email" [(ngModel)]="parent.order.C_Email" >
                    <!-- <mat-error *ngIf="formGroupErrors.C_Email.required">
                     {{translations.msgCEmailRequired}}
                    </mat-error>
                    <mat-error *ngIf="formGroupErrors.C_Email.pattern">
                      {{translations.msgEnterValidCEmail}}
                    </mat-error> -->
                </mat-form-field>
        </div>


    </form>

</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor-order/distributor-order-edit-form/dist-customer-detail/dist-customer-detail.component.html